import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { IBaseBandSetting } from "Bands/types";

const { errors, actions } = copy;
const memberProps = copy.members.memberProps;

export const getFields = ({
  memberCategories,
  manageMemberCategories,
  readOnlyEmail,
  canManageMemberCategories = false,
  readOnlyUserName,
}: {
  memberCategories: IBaseBandSetting[];
  manageMemberCategories: () => void;
  readOnlyEmail?: boolean;
  canManageMemberCategories?: boolean;
  readOnlyUserName?: boolean;
}): IFormFields => [
  {
    type: IFieldType.email,
    name: "email",
    label: memberProps.email,
    validation: {
      required: errors.required,
    },
    style: { gridColumn: "span 2" },
    disabled: readOnlyEmail,
  },
  {
    type: IFieldType.text,
    name: "firstname",
    label: memberProps.firstname,
    disabled: readOnlyUserName,
    validation: {
      required: errors.required,
    },
  },
  {
    type: IFieldType.text,
    name: "lastname",
    label: memberProps.lastname,
    disabled: readOnlyUserName,
    validation: {
      required: errors.required,
    },
  },
  {
    type: IFieldType.text,
    name: "nickname",
    label: memberProps.nickname,
  },
  {
    type: IFieldType.text,
    name: "function",
    label: memberProps.function,
  },
  {
    name: "category",
    label: memberProps.memberCategory,
    type: IFieldType.tagGroup,
    options: memberCategories?.map(({ id, ...props }) => ({
      ...props,
      value: id,
    })),
    validation: {
      required: errors.required,
    },
    ...(canManageMemberCategories && {
      fieldLink: {
        label: actions.manage,
        onClick: manageMemberCategories,
      },
    }),
    style: { gridColumn: "span 2" },
  },
];
